import { useEffect, useRef } from "react";
import { Link } from "@tanstack/react-router";
import { AuthUser } from "../lib/use-auth";

interface NavbarProps {
  user: AuthUser;
  signOut: () => void;
}

export const Navbar = (props: NavbarProps) => {
  const managementMenuRef = useRef<HTMLDetailsElement>(null);

  useEffect(() => {
    const onDocumentClick = (event: MouseEvent) => {
      const managementMenu = managementMenuRef.current;
      if (!managementMenu || !managementMenu.open) {
        return;
      }

      const target = event.target as Node | null;
      if (!target || managementMenu.contains(target)) {
        return;
      }

      managementMenu.removeAttribute("open");
    };

    document.addEventListener("click", onDocumentClick);
    return () => {
      document.removeEventListener("click", onDocumentClick);
    };
  }, []);

  const name = (email: string | undefined) => {
    if (!email) return "";
    const parts = email.split("@");
    if (parts.length === 2) {
      return parts[0];
    }
    return email;
  };

  const closeManagementMenu = () => {
    managementMenuRef.current?.removeAttribute("open");
  };

  return (
    <div className="navbar bg-base-300 shadow-sm">
      <div className="flex-1">
        <Link to="/" className="text-xl">
          MACL Zwarte cross medewerker beheer
        </Link>
      </div>
      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal px-1">
          <li>
            {props.user.roles.includes("admin") && (
              <details ref={managementMenuRef}>
                <summary>Beheer</summary>
                <ul className="p-2 bg-base-200 w-40 z-1">
                  <li>
                    <Link to="/employee" onClick={closeManagementMenu}>
                      Medewerkers
                    </Link>
                  </li>
                  <li>
                    <Link to="/material" onClick={closeManagementMenu}>
                      Materiaal
                    </Link>
                  </li>
                  <li>
                    <Link to="/management/import" onClick={closeManagementMenu}>
                      Excel inspoelen
                    </Link>
                  </li>
                </ul>
              </details>
            )}
          </li>
        </ul>
      </div>

      <div className="navbar-end">
        <span className="text-sm mr-2">{name(props.user.username)}</span>
        <button
          onClick={props.signOut}
          className="btn btn-square btn-ghost min-w-20"
        >
          Uitloggen
        </button>
      </div>
    </div>
  );
};
